<template>
  <v-container
    class="justify-center"
    fill-height
    fluid
  >
    <v-card
      max-width="550"
      width="100%"
      class="pa-8"
    >
      <v-row justify="space-between">
        <v-col cols="12">
          <v-form data-vue-component-name="Registration" ref="form">
            <component
              v-for="(field, index) in form"
              :key="index"
              :is="field.component"
              v-bind="field.attrs"
              v-model="field.value"
              class="mb-3"
            />

            <v-btn width="100%" @click="onSubmit">Submit</v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import VTextField from 'vuetify/lib/components/VTextField';
import VSelect from 'vuetify/lib/components/VSelect';
import { toSnakeCase, isEmpty } from '@/composables';
import { VALIDATIONS } from '@/constants';

export default {
  name: 'Registration',
  components: {
    VTextField,
    VSelect,
  },
  data: () => ({
    form: [
      {
        component: 'v-text-field',
        value: null,
        required: true,
        attrs: {
          type: 'text',
          label: 'First name',
          class: 'required',
          rules: [
            val => VALIDATIONS.required(val) || 'This field is required',
            val => VALIDATIONS.string(val) || 'First name must be a string',
            val => VALIDATIONS.min(val, 2) || 'Minimum number of characters 2',
            val => VALIDATIONS
              .max(val, 128) || 'Maximum number of characters 128',
          ],
        },
      },
      {
        component: 'v-text-field',
        value: null,
        required: true,
        attrs: {
          type: 'text',
          label: 'Last name',
          class: 'required',
          rules: [
            val => VALIDATIONS.required(val) || 'This field is required',
            val => VALIDATIONS.string(val) || 'Last name must be a string',
            val => VALIDATIONS.min(val, 2) || 'Minimum number of characters 2',
            val => VALIDATIONS
              .max(val, 128) || 'Maximum number of characters 128',
          ],
        },
      },
      {
        component: 'v-text-field',
        value: null,
        required: true,
        attrs: {
          type: 'email',
          label: 'Email',
          class: 'required',
          rules: [
            val => VALIDATIONS.required(val) || 'This field is required',
            val => VALIDATIONS.email(val) || 'Invalid email',
          ],
        },
      },
      {
        component: 'v-text-field',
        value: null,
        attrs: {
          type: 'number',
          label: 'Age',
          min: 16,
          max: 120,
          rules: [
            val => isEmpty(val) || (
              VALIDATIONS.min(Number(val), 16)
                ? VALIDATIONS.max(Number(val), 120)
                  || 'The age should not be more than 120 years.'
                : 'You must be at least 16 years old'
            ),
          ],
        },
      },
      {
        component: 'v-select',
        value: null,
        attrs: {
          label: 'Sex At Birth',
          items: ['Male', 'Female'],
        },
      },
      {
        component: 'v-text-field',
        value: null,
        attrs: {
          label: 'Occupation',
          rules: [
            val => isEmpty(val) || (
              VALIDATIONS.min(val, 2)
                ? VALIDATIONS.max(val, 128) || 'Maximum number of characters 128'
                : 'Minimum number of characters 2'
            ),
          ],
        },
      },
      {
        component: 'v-select',
        value: null,
        attrs: {
          label: 'Education Level',
          items: [
            'early childhood education',
            'early childhood education',
            'lower secondary education',
            'upper secondary education',
            'postsecondary non-tertiary education',
            'short-cycle tertiary education',
            'bachelor’s or equivalent level',
            'master’s or equivalent level',
            'doctor or equivalent level',
          ],
        },
      },
    ],
  }),
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    getFormData() {
      return this.form.reduce(
        (acc, field) => {
          acc[toSnakeCase(field.attrs.label)] = field.value;
          return acc;
        },
        {},
      );
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.commit('SAVE_LOG', {
          key: 'user_info',
          payload: this.getFormData(),
        });

        this.$store.commit('SET_CURRENT_STEP', 0);
        this.$router.push({ name: this.$store.getters.getStepView });
      }
    },
    onKeyDown(e) {
      if (e.key === 'Enter') this.onSubmit();
    },
  },
};
</script>

<style scoped lang="scss">
[data-vue-component-name="Registration"] {
  .required ::v-deep label::before {
    content: '* ';
  }
}
</style>
